<!-- 日营业额统计 -->
<template>
    <div class="business-content-main isumarry-content">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn" style="min-height: 0">
            <div class="search-ctn-left">
                <div class="search-name">仓库</div>
                <el-select v-model="searchData.SId" :loading="loading" class="search-item" size="small" filterable clearable
                    @visible-change="getWarehouse($event)">
                    <el-option v-for="optionItem in WarehouseList" :key="optionItem.WarehouseId"
                        :label="optionItem.WarehouseName" :value="optionItem.WarehouseId">
                        <span style="float: left">{{ optionItem.WarehouseName }}</span>
                        <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                    </el-option>
                </el-select>
                <div class="search-name">日期</div>
                <el-date-picker class="search-name" v-model="searchData.Date" size="small" type="date"
                    placeholder="选择日期"></el-date-picker>
                <el-button class="search-btn btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                <el-button class="search-btn" size="small" @click="resetSearch">重置</el-button>
                <el-button v-if="permission.print && !isDefaultSet" size="small" icon="el-icon-printer"
                    class="search-btn btn-primary" @click="printPreview()">{{
                        permission.print
                    }}</el-button>
                <el-button v-if="permission.lockAccount && !summaryData.IsLock" size="small" type="primary"
                    icon="el-icon-lock" class="search-btn" @click="lockAccount()">{{
                        permission.lockAccount
                    }}</el-button>
                <el-button v-if="permission.unlockAccount && summaryData.IsLock" size="small" type="warning"
                    icon="el-icon-unlock" class="search-btn" @click="unlockAccount()">{{
                        permission.unlockAccount
                    }}</el-button>
                <el-button v-if="permission.export" size="small" type="primary" class="search-btn" @click="exportData()">
                    <i class="fa fa-file-excel-o"></i>
                    {{ permission.export }}</el-button>
                <div class="section-summary">
                    <div>
                        <el-tooltip placement="right">
                            <div slot="content" v-html="formula.Sum"></div>
                            <i class="el-icon-warning-outline" style="color: orange"></i>
                        </el-tooltip>
                        <span> 合计：{{ summaryData.SummaryStr }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="summary-zone">
            <el-container style="height: 100%; width: 390px; margin-right: 8px">
                <div class="summary-table-main">
                    <div class="div-table-row">
                        <div class="div-table-header project">项目</div>
                        <div class="div-table-header amount">金额</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project title">出库汇总</div>
                        <div class="div-table-cell amount"></div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">总单数</div>
                        <div class="div-table-cell amount">
                            {{
                                summaryData && summaryData.Data2
                                ? Number(summaryData.Data2) + Number(summaryData && summaryData.Data6 ? summaryData.Data6 : 0)
                                : summaryData && summaryData.Data6
                                    ? summaryData.Data6
                                    : 0
                            }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">总数量</div>
                        <div class="div-table-cell amount">
                            {{
                                summaryData && summaryData.Data3
                                ? summaryData.Data3 - (summaryData && summaryData.Data7 ? summaryData.Data7 : 0)
                                : -(summaryData && summaryData.Data7 ? summaryData.Data7 : 0)
                            }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">总成本</div>
                        <div class="div-table-cell amount">
                            {{
                                (summaryData && summaryData.Data4
                                    ? summaryData.Data4 - (summaryData && summaryData.Data8 ? summaryData.Data8 : 0)
                                    : -(summaryData && summaryData.Data8 ? summaryData.Data8 : 0)
                                ).toFixed(2)
                            }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">总销售金额</div>
                        <div class="div-table-cell amount">
                            {{
                                (summaryData && summaryData.Data5
                                    ? summaryData.Data5 - (summaryData && summaryData.Data9 ? summaryData.Data9 : 0)
                                    : -(summaryData && summaryData.Data9 ? summaryData.Data9 : 0)
                                ).toFixed(2)
                            }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">总减收金额</div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data1 ? summaryData.Data1 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subctitle">出库单数</div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data2 ? summaryData.Data2 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subctitle">出库数量</div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data3 ? summaryData.Data3 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subctitle">出库成本</div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data4 ? summaryData.Data4 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subctitle">出库金额</div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data5 ? summaryData.Data5 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subctitle">出库退货单数</div>
                        <div class="div-table-cell amount c-active">{{ summaryData && summaryData.Data6 ? summaryData.Data6
                            : 0 }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subctitle">出库退货数量</div>
                        <div class="div-table-cell amount c-active">{{ summaryData && summaryData.Data7 ? summaryData.Data7
                            : 0 }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subctitle">出库退货成本</div>
                        <div class="div-table-cell amount c-active">{{ summaryData && summaryData.Data8 ? summaryData.Data8
                            : 0 }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subctitle">出库退货金额</div>
                        <div class="div-table-cell amount c-active">{{ summaryData && summaryData.Data9 ? summaryData.Data9
                            : 0 }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project title">出库明细</div>
                        <div class="div-table-cell amount"></div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">销售出库单数</div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data2 ? summaryData.Data2 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">销售出库金额</div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data5 ? summaryData.Data5 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">销售退货单数</div>
                        <div class="div-table-cell amount c-active">{{ summaryData && summaryData.Data6 ? summaryData.Data6
                            : 0 }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">销售退货金额</div>
                        <div class="div-table-cell amount c-active">{{ summaryData && summaryData.Data9 ? summaryData.Data9
                            : 0 }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">调拨出库单数</div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data10 ? summaryData.Data10 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project title">入库汇总</div>
                        <div class="div-table-cell amount"></div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">总单数</div>
                        <div class="div-table-cell amount">
                            {{
                                summaryData && summaryData.Data11
                                ? Number(summaryData.Data11) + Number(summaryData && summaryData.Data14 ? summaryData.Data14 :
                                    0)
                                : summaryData && summaryData.Data14
                                    ? summaryData.Data14
                                    : 0
                            }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">总数量</div>
                        <div class="div-table-cell amount">
                            {{
                                summaryData && summaryData.Data12
                                ? summaryData.Data12 - (summaryData && summaryData.Data15 ? summaryData.Data15 : 0)
                                : -(summaryData && summaryData.Data15 ? summaryData.Data15 : 0)
                            }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">总成本</div>
                        <div class="div-table-cell amount">
                            {{
                                (summaryData && summaryData.Data13
                                    ? summaryData.Data13 - (summaryData && summaryData.Data16 ? summaryData.Data16 : 0)
                                    : -(summaryData && summaryData.Data16 ? summaryData.Data16 : 0)
                                ).toFixed(2)
                            }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subctitle">入库单数</div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data11 ? summaryData.Data11 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subctitle">入库数量</div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data12 ? summaryData.Data12 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subctitle">入库成本</div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data13 ? summaryData.Data13 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subctitle">入库退货单数</div>
                        <div class="div-table-cell amount c-active">{{ summaryData && summaryData.Data14 ?
                            summaryData.Data14 : 0 }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subctitle">入库退货数量</div>
                        <div class="div-table-cell amount c-active">{{ summaryData && summaryData.Data15 ?
                            summaryData.Data15 : 0 }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subctitle">入库退货成本</div>
                        <div class="div-table-cell amount c-active">{{ summaryData && summaryData.Data16 ?
                            summaryData.Data16 : 0 }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project title">入库明细</div>
                        <div class="div-table-cell amount"></div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">采购入库单数</div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data11 ? summaryData.Data11 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">采购入库成本</div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data13 ? summaryData.Data13 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">采购退货单数</div>
                        <div class="div-table-cell amount c-active">{{ summaryData && summaryData.Data14 ?
                            summaryData.Data14 : 0 }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">采购退货成本</div>
                        <div class="div-table-cell amount c-active">{{ summaryData && summaryData.Data16 ?
                            summaryData.Data16 : 0 }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">调拨入库单数</div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data17 ? summaryData.Data17 : 0 }}
                        </div>
                    </div>
                </div>
            </el-container>
            <el-container style="height: 100%; width: 390px">
                <div class="summary-table-main">
                    <div class="div-table-row">
                        <div class="div-table-header project">项目</div>
                        <div class="div-table-header amount">金额</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project title">利润表</div>
                        <div class="div-table-cell amount"></div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">
                            业务收入
                            <el-tooltip placement="right">
                                <div slot="content" v-html="formula.data27"></div>
                                <i class="el-icon-warning-outline" style="color: orange"></i>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell amount">
                            {{ summaryData && summaryData.Data18 ? summaryData.Data18 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">
                            业务成本
                            <el-tooltip placement="right">
                                <div slot="content" v-html="formula.data28"></div>
                                <i class="el-icon-warning-outline" style="color: orange"></i>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data19 ? summaryData.Data19 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">
                            业务利润
                            <el-tooltip placement="right">
                                <div slot="content" v-html="formula.data29"></div>
                                <i class="el-icon-warning-outline" style="color: orange"></i>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data20 ? summaryData.Data20 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subctitle">
                            配件利润
                            <el-tooltip placement="right">
                                <div slot="content" v-html="formula.data29_1"></div>
                                <i class="el-icon-warning-outline" style="color: orange"></i>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell amount">
                            {{ ((summaryData && summaryData.Data18 ? summaryData.Data18 : 0) - (summaryData &&
                                summaryData.Data19 ? summaryData.Data19 : 0)).toFixed(2) }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subctitle">
                            退货利润
                            <el-tooltip placement="right">
                                <div slot="content" v-html="formula.data29_2"></div>
                                <i class="el-icon-warning-outline" style="color: orange"></i>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell amount">
                            {{ ((summaryData && summaryData.Data9 ? summaryData.Data9 : 0) - (summaryData &&
                                summaryData.Data8 ? summaryData.Data8 : 0)).toFixed(2) }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subctitle">
                            优惠金额
                            <el-tooltip placement="right">
                                <div slot="content" v-html="formula.data29_3"></div>
                                <i class="el-icon-warning-outline" style="color: orange"></i>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data1 ? summaryData.Data1 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subctitle">
                            减收金额
                            <el-tooltip placement="right">
                                <div slot="content" v-html="formula.data29_4"></div>
                                <i class="el-icon-warning-outline" style="color: orange"></i>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data29 ? summaryData.Data29 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">
                            业务利润率
                            <el-tooltip placement="right">
                                <div slot="content" v-html="formula.data30"></div>
                                <i class="el-icon-warning-outline" style="color: orange"></i>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data21 ? summaryData.Data21 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project title">日常收支汇总</div>
                        <div class="div-table-cell amount"></div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">
                            总收款
                            <el-tooltip placement="right">
                                <div slot="content" v-html="formula.data31"></div>
                                <i class="el-icon-warning-outline" style="color: orange"></i>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data23 ? summaryData.Data23 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row" :key="'l_' + index" v-for="(item, index) in summaryData.Data22">
                        <div class="div-table-cell project subctitle">{{ item.PayName }}</div>
                        <div class="div-table-cell amount">{{ item.Amount.toFixed(2) }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">
                            总付款
                            <el-tooltip placement="right">
                                <div slot="content" v-html="formula.data32"></div>
                                <i class="el-icon-warning-outline" style="color: orange"></i>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data25 ? summaryData.Data25 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row" :key="'i_' + index1" v-for="(item1, index1) in summaryData.Data24">
                        <div class="div-table-cell project subctitle">{{ item1.PayName }}</div>
                        <div class="div-table-cell amount">{{ item1.Amount.toFixed(2) }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">
                            挂账汇总
                            <el-tooltip placement="right">
                                <div slot="content" v-html="formula.gzhz"></div>
                                <i class="el-icon-warning-outline" style="color: orange"></i>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell amount">
                            {{ ((summaryData && summaryData.Data26 ? summaryData.Data26 : 0) - (summaryData &&
                                summaryData.Data31 ? summaryData.Data31 : 0)).toFixed(2) }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subctitle">收款挂账</div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data26 ? summaryData.Data26 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subctitle">付款挂账</div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data31 ? summaryData.Data31 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">
                            预收款汇总
                            <el-tooltip placement="right">
                                <div slot="content" v-html="formula.data46"></div>
                                <i class="el-icon-warning-outline" style="color: orange"></i>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data40 ? summaryData.Data40 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row" :key="'k_' + index1" v-for="(item1, index1) in summaryData.Data39">
                        <div class="div-table-cell project subctitle">{{ item1.PayName }}</div>
                        <div class="div-table-cell amount">{{ item1.Amount.toFixed(2) }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">
                            预付款汇总
                            <el-tooltip placement="right">
                                <div slot="content" v-html="formula.data47"></div>
                                <i class="el-icon-warning-outline" style="color: orange"></i>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data42 ? summaryData.Data42 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row" :key="'j_' + index1" v-for="(item1, index1) in summaryData.Data41">
                        <div class="div-table-cell project subctitle">{{ item1.PayName }}</div>
                        <div class="div-table-cell amount">{{ item1.Amount.toFixed(2) }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project title">应收汇总</div>
                        <div class="div-table-cell amount"></div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">
                            本期应收
                            <el-tooltip placement="right">
                                <div slot="content" v-html="formula.data33"></div>
                                <i class="el-icon-warning-outline" style="color: orange"></i>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data26 ? summaryData.Data26 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">
                            本期收款
                            <el-tooltip placement="right">
                                <div slot="content" v-html="formula.data34"></div>
                                <i class="el-icon-warning-outline" style="color: orange"></i>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data27 ? summaryData.Data27 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row" :key="'m_' + index1" v-for="(item1, index1) in summaryData.Data28">
                        <div class="div-table-cell project subctitle">{{ item1.PayName }}</div>
                        <div class="div-table-cell amount">{{ item1.Amount.toFixed(2) }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">
                            预收支付
                            <el-tooltip placement="right">
                                <div slot="content" v-html="formula.data43"></div>
                                <i class="el-icon-warning-outline" style="color: orange"></i>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data43 ? summaryData.Data43 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row" :key="'n_' + index1" v-for="(item1, index1) in summaryData.Data44">
                        <div class="div-table-cell project subctitle">{{ item1.PayName }}</div>
                        <div class="div-table-cell amount">{{ item1.Amount.toFixed(2) }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">
                            本期减收
                            <el-tooltip placement="right">
                                <div slot="content" v-html="formula.data35"></div>
                                <i class="el-icon-warning-outline" style="color: orange"></i>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data29 ? summaryData.Data29 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">累计欠款</div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data30 ? summaryData.Data30 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project title">应付汇总</div>
                        <div class="div-table-cell amount"></div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">本期应付</div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data31 ? summaryData.Data31 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">本期付款</div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data32 ? summaryData.Data32 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row" :key="'f_' + index1" v-for="(item1, index1) in summaryData.Data33">
                        <div class="div-table-cell project subctitle">{{ item1.PayName }}</div>
                        <div class="div-table-cell amount">{{ item1.Amount.toFixed(2) }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">
                            预付支付
                            <el-tooltip placement="right">
                                <div slot="content" v-html="formula.data45"></div>
                                <i class="el-icon-warning-outline" style="color: orange"></i>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data45 ? summaryData.Data45 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row" :key="'s_' + index1" v-for="(item1, index1) in summaryData.Data46">
                        <div class="div-table-cell project subctitle">{{ item1.PayName }}</div>
                        <div class="div-table-cell amount">{{ item1.Amount.toFixed(2) }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">本期减付</div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data34 ? summaryData.Data34 : 0 }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell project subtitle">累计欠款</div>
                        <div class="div-table-cell amount">{{ summaryData && summaryData.Data35 ? summaryData.Data35 : 0 }}
                        </div>
                    </div>
                    <div v-if="searchData.SId">
                        <div class="div-table-row">
                            <div class="div-table-cell project title">库存汇总</div>
                            <div class="div-table-cell amount"></div>
                        </div>
                        <div class="div-table-row">
                            <div class="div-table-cell project subtitle">库存成本金额</div>
                            <div class="div-table-cell amount">{{ summaryData && summaryData.Data36 ? summaryData.Data36 : 0
                            }}</div>
                        </div>
                        <div class="div-table-row">
                            <div class="div-table-cell project subtitle">库存数量</div>
                            <div class="div-table-cell amount">{{ summaryData && summaryData.Data37 ? summaryData.Data37 : 0
                            }}</div>
                        </div>
                        <div class="div-table-row">
                            <div class="div-table-cell project subtitle">库存种类</div>
                            <div class="div-table-cell amount">{{ summaryData && summaryData.Data38 ? summaryData.Data38 : 0
                            }}</div>
                        </div>
                    </div>
                    <div v-else :key="'sto_' + index1" v-for="(item2, index1) in summaryData.Data47">
                        <div class="div-table-row">
                            <div class="div-table-cell project title">{{ item2.StoName }} 库存汇总</div>
                            <div class="div-table-cell amount"></div>
                        </div>
                        <div class="div-table-row">
                            <div class="div-table-cell project subtitle">库存成本金额</div>
                            <div class="div-table-cell amount">{{ item2.TotalCost }}</div>
                        </div>
                        <div class="div-table-row">
                            <div class="div-table-cell project subtitle">库存数量</div>
                            <div class="div-table-cell amount">{{ item2.TotalCount }}</div>
                        </div>
                        <div class="div-table-row">
                            <div class="div-table-cell project subtitle">库存种类</div>
                            <div class="div-table-cell amount">{{ item2.TotalCate }}</div>
                        </div>
                    </div>
                </div>
            </el-container>
            <el-container style="height: 100%; width: 300px" v-loading="dateLoading">
                <div class="summary-lock-main" v-if="permission.lockAccount || permission.unlockAccount">
                    <div class="search-ctn">
                        <div class="search-ctn-left" style="color: red; margin-bottom: 5px">
                            温馨提醒：以下日期是未锁帐日期，可以通过选择日期直接进行查询对应数据</div>
                        <div class="search-ctn-left">
                            <el-date-picker v-model="dateTimes" size="small" class="search-item" type="daterange"
                                align="right" style="width: 250px" unlink-panels range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                                format="yyyy-MM-dd" value-format="yyyy-MM-dd" @change="onDateTimeSelect"></el-date-picker>
                        </div>
                        <div class="table-ctn">
                            <div>
                                <el-button class="date-btn" v-for="item in unlockDateList" :key="item" type="text"
                                    @click="dateSeleced(item)">{{ item }}</el-button>
                            </div>
                        </div>
                        <el-button class="date-btn" v-if="isHaveMore" type="text" @click="nextPage()">加载更多…</el-button>
                    </div>
                </div>
            </el-container>
        </div>
        <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="printDialogVisible" width="870px">
            <div class="dialog-content" v-if="printDialogVisible">
                <PrintDailySummary @closeDialog="closePrintDialog" :date="searchData.Date" :summaryData="summaryData"
                    :isDefaultSet="isDefaultSet" :isPreview="isPreview" :sId="searchData.SId"></PrintDailySummary>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import PrintDailySummary from '@/components/printModels/printDailySummary_TB';
export default {
    mixins: [],
    name: '',
    components: {
        breadcrumb,
        PrintDailySummary
    },
    data() {
        return {
            dateTimes: [],
            datetime1: '',
            loading: '',
            stopReq: false,
            printDialogVisible: false,
            searchData: {
                Date: '',
                SId: ''
            },
            lockSearchData: {
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            },
            isHaveMore: false,
            unlockDateList: [],
            dateLoading: false,
            summaryData: {},
            permission: {},
            isDefaultSet: true, //是否使用浏览器的打印功能
            isPreview: false, //是否出现预览界面
            isLock: false,
            formula: {
                Sum: '营业额=已提交的出库金额-出库退货金额（总销售金额=业务收入=营业额）<br/>利润=业务利润=(业务收入-业务成本)-优惠金额-减收金额-退货利润',
                data27: '业务收入=营业额=总销售金额（不扣除优惠，减收）',
                data28: '业务成本=商品采购价+销售单优惠的金额+财务本期减收的金额-退货成本',
                data29: `业务利润=(业务收入-业务成本)-退货利润`,
                data29_1: '配件利润=业务收入-业务成本',
                data29_2: '退货利润=退货总额-退货成本',
                data29_3: '优惠金额：查询时间段内所有销售单的优惠总额',
                data29_4: '减收金额：查询时间段内应收应付管理中减收金额总和',
                data30: '业务利润率=业务利润/营业额*100%',
                data31: '总收款：出库确认列表中已确认单据的总金额（不包含挂账、托收/代收）',
                data32: '总付款：入库确认列表中已确认单据的总金额（不包含挂账、托收/代收）',
                gzhz: '挂账汇总：单据确认列表中已确认的总额（仅挂账、托收/代收）',
                data33: '本期应收：按照单据已确认的时间统计',
                data34: '本期收款：根据应收应付管理中的结算日期统计',
                data35: '本期减收：根据应收应付管理的结算日期，统计减收总额',
                data43: '预收支付：根据应收应付管理的结算日期，统计使用预收客户金额抵扣',
                data45: '预付支付：根据应收应付管理的结算日期，统计使用预付供应商金额抵扣',
                data46: '预收款汇总：依据创建预收款收款日期统计；',
                data47: '预付款汇总：依据创建预付款付款日期统计；'
            },
            WarehouseList: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    //当前页面使用了keepAlive,不会触发beforeDestroy钩子
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);

        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1 - 1, 0);
        this.dateTimes.push(date1);

        this.searchData.Date = date1;

        let year2, month2, day2;
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), d.getMonth() - 1, d.getDate()];
        let date2 = new Date(year2, month2, day2, 0);
        this.dateTimes.unshift(date2);
        this.lockSearchData.StartDate = date2;
        this.lockSearchData.EndDate = date1;
    },
    mounted() {
        this.permission = this.$util.getPermission('DailySummary');
        this.getConfigByCodes().then(() => {
            this.getTableData();
        });
        if (this.permission.lockAccount || this.permission.unlockAccount) this.getUnLockDates();
    },
    methods: {
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['syllqdysz', 'dyyl'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'syllqdysz':
                                    this.isDefaultSet = result;
                                    break;
                                case 'dyyl': //是否出现预览界面
                                    this.isPreview = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            let that = this;
            if (key === 13) {
                e.preventDefault();
                that.handleSearch();
            }
        },
        resetSearch() {
            let d = new Date();
            let year1, month1, day1;
            [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
            let date1 = new Date(year1, month1, day1, 0);

            this.searchData.Date = date1;
        },
        getTableData() {
            let that = this;
            if (!that.stopReq) {
                that.stopReq = true;
                that.$util
                    .axiosGet({
                        url: '/api/RevenueManagement_H/GetDailySummary',
                        data: that.searchData
                    })
                    .then(res => {
                        let data = res.data;
                        if (!data) {
                            return;
                        }
                        that.summaryData = data;
                    })
                    .finally(() => {
                        that.stopReq = false;
                    });
            }
        },
        handleSearch() {
            this.tableData = [];
            this.getTableData();
        },
        // 打印预览
        printPreview() {
            if (!this.isDefaultSet) {
                let LODOP = this.$lodop.getLodop();
                if (!LODOP) return;
            }

            this.printDialogVisible = true;
        },
        closePrintDialog() {
            this.printDialogVisible = false;
        },
        lockAccount() {
            let that = this;
            if (!that.stopReq) {
                that.stopReq = true;
                let date = that.$util.formatDate(that.searchData.Date);
                let date_3 = that.$util.formatDateV3(that.searchData.Date);
                that.$util
                    .axiosGet({
                        url: '/api/RevenueManagement_H/CheckLockAccount',
                        data: that.searchData
                    })
                    .then(res => {
                        let isNeedC = res.data;
                        if (isNeedC) {
                            this.$confirm('还有单据未进行确认，您无法进行锁帐操作', '提示', {
                                type: 'error',
                                showCancelButton: false
                            })
                                .then(() => { })
                                .catch(() => { });
                        } else {
                            that.$util
                                .axiosPost({
                                    url: `/api/RevenueManagement_H/LockAccount?Date=${date}`
                                })
                                .then(res => {
                                    if (res.errcode == 0) {
                                        that.summaryData.IsLock = true;
                                        for (let i = 0; i < that.unlockDateList.length; i++) {
                                            if (that.unlockDateList[i] == date_3) {
                                                that.unlockDateList.splice(i, 1);
                                            }
                                        }
                                    }
                                    that.$util.successMsg(res.errmsg);
                                })
                                .finally(() => {
                                    that.stopReq = false;
                                });
                        }
                    })
                    .finally(() => {
                        that.stopReq = false;
                    });
            }
        },
        unlockAccount() {
            let that = this;
            if (!that.stopReq) {
                that.stopReq = true;
                let date = that.$util.formatDate(that.searchData.Date);
                that.$util
                    .axiosPost({
                        url: `/api/RevenueManagement_H/UnlockAccount?Date=${date}`
                    })
                    .then(res => {
                        if (res.errcode == 0) {
                            that.summaryData.IsLock = false;
                        }
                        that.$util.successMsg(res.errmsg);
                    })
                    .finally(() => {
                        that.stopReq = false;
                    });
            }
        },
        getWarehouse(event) {
            let that = this;
            if (event && this.WarehouseList.length == 0) {
                that.loading = true;
                that.$util.getWarehouse(1).then(data => {
                    that.WarehouseList = data;
                    that.loading = false;
                });
            }
        },
        // 导出
        exportData() {
            let that = this;
            if (that.summaryData) {
                this.$util.elConfirm({
                    content: '确定导出日营业统计吗？',
                    noMsg: true,
                    confirm() {
                        let reqData = { ...that.summaryData, Date: that.searchData.Date };
                        that.$util.exportFile_post({
                            url: '/api/RevenueManagement_H/ExportSummaryDatas',
                            data: reqData
                        });
                    }
                });
            } else {
                that.$util.warningMsg('请筛选数据');
                return;
            }
        },
        onDateTimeSelect(val) {
            this.lockSearchData.page = 1;
            if (val != null) {
                this.lockSearchData.StartDate = val[0];
                this.lockSearchData.EndDate = val[1];
            } else {
                this.lockSearchData.StartDate = '';
                this.lockSearchData.EndDate = '';
            }
            this.getUnLockDates();
        },
        getUnLockDates() {
            let that = this;
            that.dateLoading = true;
            that.$util
                .axiosGet({
                    url: '/api/RevenueManagement_H/GetUnLockDates',
                    data: that.lockSearchData,
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        return;
                    }
                    if (that.lockSearchData.page == 1) that.unlockDateList = data;
                    else that.unlockDateList = that.unlockDateList.concat(data);

                    that.isHaveMore = res.count > that.unlockDateList.length;
                })
                .finally(() => {
                    that.dateLoading = false;
                });
        },
        dateSeleced(date) {
            this.searchData.Date = date;
            this.handleSearch();
        },
        nextPage() {
            this.lockSearchData.page += 1;
            this.getUnLockDates();
        }
    }
};
</script>
<style lang="less" scoped>
.date-btn {
    margin-left: 10px;
}

.c-active {
    color: #0ccc56 !important;
}

.summary-zone {
    display: flex;
    flex-direction: row;
    width: 1120px;
    margin-bottom: 20px;
}

.summary-table-main {
    width: 390px;
    font-size: 12px;

    .div-table-header {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 30px;
        padding-left: 10px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        color: #000;
        background-color: rgb(242, 246, 252);
    }

    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 26px;
        padding-left: 10px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        color: #000;
    }

    .div-table-row {
        border-left: 1px solid #000;

        .project {
            width: 220px;
        }

        .amount {
            width: 170px;
        }

        .title {
            font-weight: 700;
        }

        .subtitle {
            padding-left: 25px;
        }

        .subctitle {
            padding-left: 50px;
        }
    }
}

.summary-lock-main {
    margin-left: 5px;
    width: 300px;
    font-size: 12px;
    border: 1px solid rgb(173, 171, 171);
    padding: 10px;
    color: #000;
}

.section-summary {
    margin-left: 20px;
}
</style>